<div>
    <nz-spin [nzSpinning]="isLoading">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
            <h2>NEW BREAKDOWN</h2>
        </div>

        @if (showWhatsappNotification) {
            <nz-alert nzType="info" nzCloseable (nzOnClose)="showWhatsappNotification = false" 
                nzMessage="WhatsApp Message Received" 
                nzDescription="Incident details have been updated with data from WhatsApp message." 
                nzShowIcon style="margin-bottom: 16px;">
            </nz-alert>
        }
        
        <form nz-form [nzLayout]="'horizontal'">
            <!-- CLIENT DETAILS SECTION -->
            <nz-card nzTitle="CLIENT DETAILS" style="margin-bottom: 16px;">
                <div nz-row [nzGutter]="16">
                    <!-- Fleet Selection -->
                    <div nz-col [nzSpan]="8">
                        @if (incident.clientId === 0) {
                            <nz-form-item>
                                <nz-form-label nzRequired>Fleet</nz-form-label>
                                <nz-form-control>
                                    <nz-input-group nzCompact [nzAddOnAfter]="addFleetBtn">
                                        <button nz-button nz-dropdown [nzDropdownMenu]="fleets" [nzType]="'default'" style="width: 100%; text-align: left;">
                                            SELECT FLEET
                                            <nz-icon nzType="down" style="float: right; margin-top: 4px;" />
                                        </button>
                                    </nz-input-group>
                                    <ng-template #addFleetBtn>
                                        <button nz-button nzType="default" (click)="onAddNewFleet()" nz-tooltip="Add New Fleet">
                                            <nz-icon nzType="plus-circle" nzTheme="outline" />
                                        </button>
                                    </ng-template>
                                </nz-form-control>
                            </nz-form-item>
                        }
                        @else {
                            <nz-form-item>
                                <nz-form-label>Fleet</nz-form-label>
                                <nz-form-control>
                                    <strong>{{incident.clientName}}</strong>
                                </nz-form-control>
                            </nz-form-item>
                        }
                    </div>

                    @if (incident.clientId && incident.clientId > 0) {
                        <!-- Vehicle Selection -->
                        <div nz-col [nzSpan]="8">
                            <nz-form-item>
                                <nz-form-label nzRequired>Vehicle</nz-form-label>
                                <nz-form-control nzHasFeedback [nzValidateStatus]="isLoadingFleetVehicles ? 'validating' : ''">
                                    @if (!incident.fleetVehicle || (!incident.fleetVehicle.vehicleId && !incident.fleetVehicle.registrationNumber)) {
                                        <nz-input-group nzCompact [nzAddOnAfter]="addVehicleBtn">
                                            <nz-select nzShowSearch nzAllowClear nzMode="default" nzPlaceHolder="Select Vehicle"
                                                [(ngModel)]="incident.fleetVehicle.vehicleId" [ngModelOptions]="{standalone: true}" 
                                                (ngModelChange)="onVehicleChanged($event)" style="width: 100%;">
                                                    @for (item of fleetVehicles; track $index) {
                                                        <nz-option [nzLabel]="item.registrationNumber" [nzValue]="item.vehicleId"></nz-option>
                                                    }
                                            </nz-select>
                                        </nz-input-group>
                                        <ng-template #addVehicleBtn>
                                            <button nz-button nzType="default" (click)="onAddNewVehicle()" nz-tooltip="Add New Vehicle">
                                                <nz-icon nzType="plus-circle" nzTheme="outline" />
                                            </button>
                                        </ng-template>
                                        @if (incident.fleetVehicle.registrationNumber) {
                                            <div style="margin-top: 4px;"><small>{{incident.fleetVehicle.registrationNumber}}</small></div>
                                        }
                                    }
                                    @else {
                                        @if (incident.fleetVehicle.vehicleId === 0) {
                                            <input nz-input placeholder="Enter registration number" 
                                                id="vehicleRegNumber" name="vehicleRegNumber" type="text" 
                                                [(ngModel)]="incident.fleetVehicle.registrationNumber" 
                                                [appWhatsappField]="'fleetVehicle'"
                                                [whatsappFlags]="fieldsFromWhatsapp"
                                                style="margin-bottom: 8px;" />
                                            <input nz-input placeholder="Enter VIN number (optional)" 
                                                id="vehicleVinNumber" name="vehicleVinNumber" type="text" 
                                                [(ngModel)]="incident.fleetVehicle.vinNumber" 
                                                [appWhatsappField]="'fleetVehicle'"
                                                [whatsappFlags]="fieldsFromWhatsapp" />
                                        }
                                        @else {
                                            <strong>{{incident.fleetVehicle.registrationNumber}}</strong>
                                            @if (incident.fleetVehicle.vinNumber) {
                                                <div style="margin-top: 4px;"><small>VIN: {{incident.fleetVehicle.vinNumber}}</small></div>
                                            }
                                        }
                                    }
                                </nz-form-control>
                            </nz-form-item>
                        </div>

                        <!-- Driver Selection -->
                        <div nz-col [nzSpan]="8">
                            <nz-form-item>
                                <nz-form-label nzRequired>Driver</nz-form-label>
                                <nz-form-control nzHasFeedback [nzValidateStatus]="isLoadingTruckDrivers ? 'validating' : ''">
                                    @if (!incident.driver.driverId && !incident.driver.phoneNumber) {
                                        <nz-input-group nzCompact [nzAddOnAfter]="addDriverBtn">
                                            <nz-select nzShowSearch nzAllowClear nzMode="default" nzPlaceHolder="Select Driver"
                                                [(ngModel)]="incident.driver.driverId" [ngModelOptions]="{standalone: true}" 
                                                (ngModelChange)="onDriverChanged($event)" style="width: 100%;">
                                                    @for (item of truckDrivers; track $index) {
                                                        <nz-option [nzLabel]="item.name + ' (' + item.phoneNumber + ')' " [nzValue]="item.driverId"></nz-option>
                                                    }
                                            </nz-select>
                                        </nz-input-group>
                                        <ng-template #addDriverBtn>
                                            <button nz-button nzType="default" (click)="onAddNewDriver()" nz-tooltip="Add New Driver">
                                                <nz-icon nzType="plus-circle" nzTheme="outline" />
                                            </button>
                                        </ng-template>
                                        @if (incident.driver.name || incident.driver.phoneNumber) {
                                            <div style="margin-top: 4px;"><small>{{incident.driver.name ? incident.driver.name : ''}} {{incident.driver.phoneNumber ? ' (TEL: ' + incident.driver.phoneNumber + ')' : ''}}</small></div>
                                        }
                                    }
                                    @else {
                                        @if (incident.driver.driverId === 0) {
                                            <input nz-input placeholder="Enter driver name" 
                                                id="driverName" name="driverName" type="text" 
                                                [(ngModel)]="incident.driver.name" 
                                                [appWhatsappField]="'driver'"
                                                [whatsappFlags]="fieldsFromWhatsapp"
                                                style="margin-bottom: 8px;" />
                                            <input nz-input placeholder="Enter phone number" 
                                                id="driverPhone" name="driverPhone" type="text" 
                                                [(ngModel)]="incident.driver.phoneNumber" 
                                                [appWhatsappField]="'driver'"
                                                [whatsappFlags]="fieldsFromWhatsapp" />
                                        }
                                        @else {
                                            <strong>{{incident.driver.name}}</strong>
                                            @if (incident.driver.phoneNumber) {
                                                <div style="margin-top: 4px;"><small>Tel: {{incident.driver.phoneNumber}}</small></div>
                                            }
                                        }
                                    }
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                    }
                </div>
            </nz-card>

            <!-- BREAKDOWN DETAILS SECTION -->
            @if (incident.clientId && incident.clientId > 0 && (incident.fleetVehicle.vehicleId || incident.fleetVehicle.registrationNumber) && (incident.driver.driverId || incident.driver.phoneNumber)) {
                <nz-card nzTitle="BREAKDOWN DETAILS" style="margin-bottom: 16px;">
                    
                    <!-- Incident Type -->
                    <nz-form-item>
                        <nz-form-label nzRequired>Type</nz-form-label>
                        <nz-form-control>
                            <nz-space>
                                <button *nzSpaceItem nz-button [nzType]="incident.incidentType === incidentType.Tyre ? 'primary' : 'default'" 
                                    (click)="onSelectIncidentType(incidentType.Tyre)">Tyre</button>
                                <button *nzSpaceItem nz-button [nzType]="incident.incidentType === incidentType.Mechanical ? 'primary' : 'default'" 
                                    (click)="onSelectIncidentType(incidentType.Mechanical)">Mechanical</button>
                            </nz-space>
                        </nz-form-control>
                    </nz-form-item>

                    <!-- Tyre Details (only if Tyre type) -->
                    @if (incident.incidentType === incidentType.Tyre || incident.incidentType === incidentType.Both) {
                        
                        <!-- Tyre Positions -->
                        <nz-form-item>
                            <nz-form-label>Tyre Positions</nz-form-label>
                            <nz-form-control>
                                <div nz-row [nzGutter]="[8, 8]">
                                    <div nz-col [nzSpan]="8">
                                        <button nz-button nzBlock [nzSize]="'default'" 
                                            [nzType]="hasTyreInLocation(tyreLocation.steer) ? 'primary' : 'default'" 
                                            (click)="onClickTyreLocation(tyreLocation.steer)">
                                            <nz-icon nzType="car" nzTheme="outline" /> Steer
                                        </button>
                                    </div>
                                    <div nz-col [nzSpan]="8">
                                        <button nz-button nzBlock [nzSize]="'default'" 
                                            [nzType]="hasTyreInLocation(tyreLocation.drive) ? 'primary' : 'default'" 
                                            (click)="onClickTyreLocation(tyreLocation.drive)">
                                            <nz-icon nzType="build" nzTheme="outline" /> Drive
                                        </button>
                                    </div>
                                    <div nz-col [nzSpan]="8">
                                        <button nz-button nzBlock [nzSize]="'default'" 
                                            [nzType]="hasTyreInLocation(tyreLocation.trailer) ? 'primary' : 'default'" 
                                            (click)="onClickTyreLocation(tyreLocation.trailer)">
                                            <nz-icon nzType="block" nzTheme="outline" /> Trailer
                                        </button>
                                    </div>
                                </div>
                                
                                <!-- Display selected tyres -->
                                @if (getTyresInPosition(tyreLocation.steer).length > 0) {
                                    <div style="margin-top: 12px;">
                                        <nz-divider nzText="STEER TYRES" nzOrientation="left"></nz-divider>
                                        @for (item of getTyresInPosition(tyreLocation.steer); track $index) {
                                            <app-incident-tyre [incidentTyre]="item"></app-incident-tyre>
                                        }
                                    </div>
                                }
                                @if (getTyresInPosition(tyreLocation.drive).length > 0) {
                                    <div style="margin-top: 12px;">
                                        <nz-divider nzText="DRIVE TYRES" nzOrientation="left"></nz-divider>
                                        @for (item of getTyresInPosition(tyreLocation.drive); track $index) {
                                            <app-incident-tyre [incidentTyre]="item"></app-incident-tyre>
                                        }
                                    </div>
                                }
                                @if (getTyresInPosition(tyreLocation.trailer).length > 0) {
                                    <div style="margin-top: 12px;">
                                        <nz-divider nzText="TRAILER TYRES" nzOrientation="left"></nz-divider>
                                        @for (item of getTyresInPosition(tyreLocation.trailer); track $index) {
                                            <app-incident-tyre [incidentTyre]="item"></app-incident-tyre>
                                        }
                                    </div>
                                }
                            </nz-form-control>
                        </nz-form-item>

                        <!-- Tyre Type/Brand -->
                        <nz-form-item>
                            <nz-form-label nzRequired>Tyre Type</nz-form-label>
                            <nz-form-control>
                                <nz-space [nzWrap]="true">
                                    <button *nzSpaceItem nz-button [nzType]="isTyreTypeSelected(-1) ? 'primary' : 'default'" 
                                        (click)="onSelectTyreType(-1)">Import</button>
                                    <button *nzSpaceItem nz-button [nzType]="isTyreTypeSelected(-2) ? 'primary' : 'default'" 
                                        (click)="onSelectTyreType(-2)">Retread</button>
                                    <nz-select *nzSpaceItem [nzMaxTagCount]="2" [nzMaxTagPlaceholder]="tyresTagOverflow" 
                                        nzMode="multiple" nzAllowClear nzPlaceHolder="Specific Brands"
                                        [(ngModel)]="incident.tyreBrands" [ngModelOptions]="{standalone: true}" style="min-width: 250px;">
                                            @for (item of sharedDataService.premiumTyreBrands; track $index) {
                                                <nz-option [nzLabel]="item.brandName" [nzValue]="item.tyreBrandId"></nz-option>
                                            }
                                    </nz-select>
                                    <ng-template #tyresTagOverflow let-selectedList>{{ selectedList.length }} more...</ng-template>
                                    <button *nzSpaceItem nz-button [nzType]="isTyreTypeSelected(-3) ? 'primary' : 'default'" 
                                        (click)="onSelectTyreType(-3)">Any</button>
                                </nz-space>
                            </nz-form-control>
                        </nz-form-item>
                    }

                    <!-- Breakdown Description -->
                    <nz-form-item>
                        <nz-form-label>Breakdown Description</nz-form-label>
                        <nz-form-control>
                            <textarea nz-input placeholder="Describe the breakdown..." 
                                id="incidentDescription" name="incidentDescription" 
                                [(ngModel)]="incident.incidentDescription" 
                                [appWhatsappField]="'incidentDescription'"
                                [whatsappFlags]="fieldsFromWhatsapp"
                                [nzAutosize]="{ minRows: 3, maxRows: 6 }"></textarea>
                        </nz-form-control>
                    </nz-form-item>

                    <!-- Vehicle ODO -->
                    <nz-form-item>
                        <nz-form-label>Vehicle ODO</nz-form-label>
                        <nz-form-control>
                            <nz-input-number id="fleetVehicleOdoReading" name="fleetVehicleOdoReading" 
                                [(ngModel)]="incident.fleetVehicleOdoReading" nzMin="0" 
                                [appWhatsappField]="'fleetVehicleOdoReading'"
                                [whatsappFlags]="fieldsFromWhatsapp"
                                [nzFormatter]="formatterKm" [nzParser]="parserKm" style="width: 200px;"/>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-divider></nz-divider>
                    <!-- Breakdown Location -->
                    <nz-form-item>
                        <nz-form-label nzRequired>Saved Locations</nz-form-label>
                        <nz-form-control>
                            @if (sharedDataService.savedLocations.length > 0) {
                                <div style="margin-bottom: 8px;">
                                    <input nz-input nzSize="default" placeholder="Or select/search on map" 
                                        id="savedLocationSelect" name="savedLocationSelect" type="text" 
                                        [(ngModel)]="selectedSaveLocationId" [nzAutocomplete]="savedLocationsAutocomplete" 
                                        (ngModelChange)="onSavedLocationModelChange($event)" style="width: 100%;" />
                                    <nz-autocomplete #savedLocationsAutocomplete>
                                        @for (item of sharedDataService.savedLocations; track $index) {
                                            <nz-auto-option [nzValue]="item.savedLocationId" [nzLabel]="item.description">
                                                {{item.description}}
                                            </nz-auto-option>
                                        }
                                    </nz-autocomplete>
                                </div>
                            }
                            
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-control>
                        <app-map-select [mapMarkerLocation]="incident.location" (locationSelected)="onMapSelected($event)"></app-map-select>
                            
                            @if (incident.location && incident.location.latitude && incident.location.longitude) {
                                <div style="margin-top: 12px; padding: 12px; background-color: #f0f2f5; border-radius: 4px;">
                                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                                        <strong>Location Details:</strong>
                                        <button nz-button nzType="default" nzSize="small" (click)="isSavedLocationNameModalVisible = true">
                                            <nz-icon nzType="save" nzTheme="outline" /> Save Location
                                        </button>
                                    </div>
                                    <div><strong>Description:</strong> {{ incident.location.description || 'N/A' }}</div>
                                    <div><strong>Coordinates:</strong> {{ incident.location.latitude }}, {{ incident.location.longitude }}</div>
                                </div>
                            }
                        </nz-form-control>
                    </nz-form-item>

                </nz-card>
            }

            <!-- Save Button -->
            @if (incident.clientId && incident.clientId > 0 && (incident.fleetVehicle.vehicleId || incident.fleetVehicle.registrationNumber) && (incident.driver.driverId || incident.driver.phoneNumber)) {
                
                <!-- Service Provider Selection -->
                <nz-card nzTitle="SERVICE PROVIDER" style="margin-bottom: 16px;">
                    <nz-form-item>
                        <nz-form-label nzRequired>Select Service Provider</nz-form-label>
                        <nz-form-control>
                            <nz-select nzShowSearch nzMode="default" 
                                nzPlaceHolder="Search and select service provider..."
                                [(ngModel)]="selectedServiceProviderId" [ngModelOptions]="{standalone: true}" 
                                (ngModelChange)="onServiceProviderSelected($event)"
                                style="width: 100%;">
                                    @for (item of getServiceProviders(); track item.clientId) {
                                        <nz-option [nzLabel]="item.clientName" [nzValue]="item.clientId"></nz-option>
                                    }
                            </nz-select>
                        </nz-form-control>
                    </nz-form-item>

                    @if (getSelectedServiceProvider()) {
                        <nz-alert nzType="info" [nzMessage]="'Selected: ' + getSelectedServiceProvider()!.clientName" nzShowIcon style="margin-top: 8px;"></nz-alert>
                    }
                </nz-card>

                <!-- Close Incident Details -->
                <nz-card nzTitle="CLOSE INCIDENT DETAILS" style="margin-bottom: 16px;">
                    <nz-form-item>
                        <nz-form-label>Order Number</nz-form-label>
                        <nz-form-control>
                            <input nz-input placeholder="Enter order number" id="orderNumber" name="orderNumber" 
                                type="text" [(ngModel)]="incident.orderNumber" />
                        </nz-form-control>
                    </nz-form-item>

                    <nz-form-item>
                        <nz-form-label>Date Completed</nz-form-label>
                        <nz-form-control>
                            <nz-space>
                                <nz-date-picker *nzSpaceItem id="dtCompleted" name="dtCompleted" 
                                    [(ngModel)]="incident.dtCompleted" nzFormat="yyyy-MM-dd" style="width: 180px;"></nz-date-picker>
                                <nz-time-picker *nzSpaceItem id="timeCompleted" name="timeCompleted" 
                                    [(ngModel)]="incident.dtCompleted" nzFormat="HH:mm" style="width: 120px;"></nz-time-picker>
                            </nz-space>
                        </nz-form-control>
                    </nz-form-item>

                    <nz-form-item>
                        <nz-form-label>Work Done</nz-form-label>
                        <nz-form-control>
                            <input nz-input placeholder="Select or type work done" id="workDone" 
                                [(ngModel)]="incident.workDone" name="workDone" [nzAutocomplete]="workDoneAuto" />
                            <nz-autocomplete #workDoneAuto>
                                @for (option of sharedDataService.workDoneTypes; track option.id) {
                                    <nz-auto-option [nzValue]="option.value">{{ option.value }}</nz-auto-option>
                                }
                            </nz-autocomplete>
                        </nz-form-control>
                    </nz-form-item>

                    <nz-form-item>
                        <nz-form-label>Comments</nz-form-label>
                        <nz-form-control>
                            <textarea nz-input placeholder="Additional comments" id="comment" name="comment" 
                                [(ngModel)]="incident.comment" [nzAutosize]="{ minRows: 2, maxRows: 4 }"></textarea>
                        </nz-form-control>
                    </nz-form-item>
                </nz-card>

                <!-- Proof of Work Documents -->
                <nz-card nzTitle="PROOF OF WORK IMAGES" style="margin-bottom: 16px;">
                    <button nz-button nzType="primary" (click)="isUploadModalVisible = true">
                        <nz-icon nzType="upload" nzTheme="outline" /> Upload Images
                    </button>

                    @if (incident.documents && incident.documents.length > 0) {
                        <div nz-row [nzGutter]="[16, 16]" class="document-gallery" style="margin-top: 16px;">
                            @for (item of visibleDocuments; track item.documentId) {
                                <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="6" [nzXl]="4" [nzXXl]="4">
                                    <app-incident-document-tile [document]="item" [incidentStatusId]="incident.statusId" (assignWorkReport)="onClickAssignWorkReport($event)" [incidentId]="0"></app-incident-document-tile>
                                </div>
                            }
                        </div>
                    }
                </nz-card>

                <nz-form-item style="text-align: center; margin-top: 24px;">
                    <nz-form-control>
                        <button nz-button nzType="primary" nzSize="large" (click)="onSaveIncident()" [nzLoading]="isLoading"
                            [disabled]="!isFormValid()">
                            <nz-icon nzType="save" nzTheme="outline" /> Save Breakdown
                        </button>
                    </nz-form-control>
                </nz-form-item>
            }
        </form>
    </nz-spin>
</div>

<!-- Modals -->
<nz-dropdown-menu #fleets="nzDropdownMenu">
    <ul nz-menu>
        @for (item of sharedDataService.getFleets; track $index) {
            <li nz-menu-item (click)="onSelectFleet(item)">
                <a>{{ item.clientName }}</a>
            </li>
        }
    </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #pricingTemplates="nzDropdownMenu">
    <ul nz-menu>
        @for (item of sharedDataService.priceTemplates; track $index) {
            <li nz-menu-item (click)="onSelectFleetPricing(item)">
                <a>{{ item.pricingName }}</a>
            </li>
        }
    </ul>
</nz-dropdown-menu>

<nz-modal [(nzVisible)]="isSavedLocationNameModalVisible" nzTitle="Save Location Details" 
    (nzOnCancel)="isSavedLocationNameModalVisible = false" (nzOnOk)="onClickSaveLocation()">
    <ng-container *nzModalContent>
        <nz-form-item>
            <nz-form-label nzRequired>Description</nz-form-label>
            <nz-form-control>
                <input nz-input placeholder="Location Description" id="savedLocationDescription" 
                    name="savedLocationDescription" type="text" [(ngModel)]="savedLocation.description" />
            </nz-form-control>
        </nz-form-item>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isAddDriverModalVisible" nzTitle="Add New Driver" 
    (nzOnCancel)="isAddDriverModalVisible = false" (nzOnOk)="onConfirmAddDriver()"
    nzOkText="Add Driver" nzCancelText="Cancel" [nzOkLoading]="isLoading">
    <ng-container *nzModalContent>
        <form nz-form>
            <nz-form-item>
                <nz-form-label nzRequired>Driver Name</nz-form-label>
                <nz-form-control>
                    <input nz-input placeholder="Enter driver name" id="newDriverName" name="newDriverName" 
                        type="text" [(ngModel)]="incident.driver.name" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Phone Number</nz-form-label>
                <nz-form-control>
                    <input nz-input placeholder="Enter phone number" id="newDriverPhone" name="newDriverPhone" 
                        type="text" [(ngModel)]="incident.driver.phoneNumber" />
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isAddVehicleModalVisible" nzTitle="Add New Vehicle" 
    (nzOnCancel)="isAddVehicleModalVisible = false" (nzOnOk)="onConfirmAddVehicle()"
    nzOkText="Add Vehicle" nzCancelText="Cancel" [nzOkLoading]="isLoading">
    <ng-container *nzModalContent>
        <form nz-form>
            <nz-form-item>
                <nz-form-label nzRequired>Registration Number</nz-form-label>
                <nz-form-control>
                    <input nz-input placeholder="Enter registration number" id="newVehicleReg" 
                        name="newVehicleReg" type="text" [(ngModel)]="incident.fleetVehicle.registrationNumber" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>VIN Number</nz-form-label>
                <nz-form-control>
                    <input nz-input placeholder="Enter VIN number (optional)" id="newVehicleVin" 
                        name="newVehicleVin" type="text" [(ngModel)]="incident.fleetVehicle.vinNumber" />
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isAddFleetModalVisible" nzTitle="Add Fleet" 
    (nzOnCancel)="isAddFleetModalVisible = false" (nzOnOk)="onConfirmAddFleet()"
    nzOkText="Add Fleet" nzCancelText="Cancel" [nzOkLoading]="isLoading">
    <ng-container *nzModalContent>
        <form nz-form>
            <nz-form-item>
                <nz-form-label nzRequired>Fleet Name</nz-form-label>
                <nz-form-control>
                    <input nz-input placeholder="Enter fleet name" id="newFleetName" name="newFleetName" 
                        type="text" [(ngModel)]="fleetClient.clientName" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Pricing</nz-form-label>
                <nz-form-control>
                    <button nz-button nz-dropdown [nzDropdownMenu]="pricingTemplates" [nzType]="'default'">
                        @if (selectedPricing && selectedPricing.pricingTemplateId > 0) {
                            {{selectedPricing.pricingName}}
                        } @else {
                            SELECT PRICING
                        }
                        <nz-icon nzType="down" />
                    </button>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Operator Name</nz-form-label>
                <nz-form-control>
                    <input nz-input placeholder="Enter operator name" id="newFleetOperatorName" 
                        name="newFleetOperatorName" type="text" [(ngModel)]="fleetClient.operatorName" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Operator Cell Number</nz-form-label>
                <nz-form-control>
                    <input nz-input placeholder="Enter operator cell number" id="newFleetOperatorCell" 
                        name="newFleetOperatorCell" type="text" [(ngModel)]="fleetClient.operatorCell" />
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isUploadModalVisible" nzTitle="Upload Proof of Work Images" 
    (nzOnCancel)="isUploadModalVisible = false" (nzOnOk)="handleUploadOk()">
    <ng-container *nzModalContent>
        <app-file-uploader [incidentId]="0" [documentClassification]="1" 
            (uploadedDocuments)="onUploadComplete($event)"></app-file-uploader>
    </ng-container>
</nz-modal>
